// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__gAW0G","list":"PatternAutocomplete_list__3F8lg"};